<template>
  <div class="d-flex">
    <b-btn
      v-b-tooltip.hover
      title="Dados do Encerramento"
      variant="none"
      class="btn btn-none rounded-pill icone-acao p-0 btn-none ml-1"
      @click="abrirDebitosEncerramento"
    >
      <font-awesome-icon
        :icon="faList"
        class="text-primary"
      />
    </b-btn>
    <b-btn
      v-b-tooltip.hover
      title="Visualizar Débitos"
      variant="none"
      class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none"
      @click="abrirDebitos"
    >
      <font-awesome-icon
        :icon="faMagnifyingGlass"
        class="text-primary"
      />
    </b-btn>
    <b-btn
      v-b-tooltip.hover
      title="Visualizar Suspensões"
      variant="none"
      class="btn btn-none rounded-pill m-0 icone-acao p-0 btn-none mr-1"
      @click="abrirSuspensoes"
    >
      <font-awesome-icon
        :icon="faFileExcel"
        class="text-primary"
      />
    </b-btn>
    <DebitosEncerramento
      v-if="mostrarDebitosEncerramento"
      :empresa-nome="gridProps.row && gridProps.row.razaoSocial ? gridProps.row.razaoSocial : ''"
      :empresa-id="gridProps.row && (gridProps.row.empresaId || gridProps.row.id)"
      :id-apuracao="gridProps.row && gridProps.row.idApuracao"
      :periodo-apuracao="gridProps.row && gridProps.row.periodoApuracao ? gridProps.row.periodoApuracao : ''"
      @hidden="fecharDebitosEncerramento"
    />
    <Debitos
      v-if="mostrarDebitos"
      :empresa-nome="gridProps.row && gridProps.row.razaoSocial ? gridProps.row.razaoSocial : ''"
      :empresa-id="gridProps.row && (gridProps.row.empresaId || gridProps.row.id)"
      :id-apuracao="gridProps.row && gridProps.row.idApuracao"
      :is-filtro-data-aplicada="isFiltroDataAplicada"
      :filtro-atual="filtroAtual"
      @hidden="fecharDebitos"
    />
    <Suspensoes
      v-if="mostrarSuspensoes"
      :empresa-nome="gridProps.row && gridProps.row.razaoSocial ? gridProps.row.razaoSocial : ''"
      :empresa-id="gridProps.row && (gridProps.row.empresaId || gridProps.row.id)"
      :id-apuracao="gridProps.row && gridProps.row.idApuracao"
      :periodo-apuracao="gridProps.row && gridProps.row.periodoApuracao ? gridProps.row.periodoApuracao : ''"
      @hidden="fecharSuspensoes"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faList, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { faFileExcel } from '@fortawesome/free-regular-svg-icons'

export default {
  name: 'Acoes',
  components: {
    Debitos: () => import('../views/DebitosView.vue'),
    DebitosEncerramento: () => import('../views/DebitosEncerramentoView.vue'),
    Suspensoes: () => import('../views/SuspensoesView.vue'),
    FontAwesomeIcon,
  },
  props: {
    gridProps: {
      type: Object,
      required: true,
    },
    isFiltroDataAplicada: {
      type: Boolean,
      default: false,
    },
    filtroAtual: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      mostrarDebitos: false,
      mostrarDebitosEncerramento: false,
      mostrarSuspensoes: false,
      faMagnifyingGlass,
      faList,
      faFileExcel,
    }
  },
  methods: {
    abrirDebitos() {
      // Apenas abre o modal e deixa a página consumir o endpoint
      if (!this.mostrarDebitos) {
        this.mostrarDebitos = true
      }
    },
    fecharDebitos() {
      this.mostrarDebitos = false
    },
    abrirDebitosEncerramento() {
      // Abre o modal de débitos de encerramento
      if (!this.mostrarDebitosEncerramento) {
        this.mostrarDebitosEncerramento = true
      }
    },
    fecharDebitosEncerramento() {
      this.mostrarDebitosEncerramento = false
    },
    abrirSuspensoes() {
      // Abre o modal de suspensões
      if (!this.mostrarSuspensoes) {
        this.mostrarSuspensoes = true
      }
    },
    fecharSuspensoes() {
      this.mostrarSuspensoes = false
    },
  },
}
</script>

<style lang="scss">
@import "../../styles/acoes.scss";
</style>
